var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',_vm._g(_vm._b({key:_vm.nSrc,ref:"img",attrs:{"src":_vm.nSrc}},'img',_vm.nAttrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }